export default {
  message: {
    "error": "Ôi! Có gì đó không đúng.",
    "Sorrysomeerrorsoccurred": "Đã xảy ra một lỗi không mong muốn. Bạn có thể thử chuyển đổi ngôn ngữ hoặc thoát và khởi động lại ứng dụng.",
    "quit": "Thoát",
    "language": "Ngôn ngữ",
    "Youcanchangethelanguagehere": "Bạn có thể thay đổi ngôn ngữ ở đây!",
    "current": "Hiện tại",
    "home": "Trang chủ",
    "friends": "Bạn bè",
    "wallet": "Ví",
    "aboutus": "Về chúng tôi",
    "Sharewithfriends": "Chia sẻ với bạn bè",
    "copyFailure": "Không thể sao chép",
    "copySuccess": "Sao chép thành công",
    "Claimreward": "Nhận phần thưởng",
    "DailyLogin": "Đăng nhập hàng ngày",
    "noInvitationsYet": "Chưa có lời mời nào",
    "LoadMore": "Tải thêm",
    "WatchAD": "Xem quảng cáo",
    "continue": "Tiếp tục",
    "Congratulations": "Xin chúc mừng",
    "MyFriends": "Bạn của tôi",
    "Invitefriends": "Mời bạn bè",
    "Invitepremiumfriends": "Mời bạn bè cao cấp",
    "DailyTasks": "Các nhiệm vụ hàng ngày",
    "inviteDesc": "+{num} ${name} cho mỗi bạn bè bạn mời",
    "DailyTasksDesc": "Hoàn thành nhiệm vụ để nhận thêm airdrop",
    "SponsorsandPartners": "Các Nhà tài trợ và Đối tác",
    "Receivingwallet": "Ví nhận",
    "Enterwalletaddress": "Nhập địa chỉ ví {name}",
    "Claim": "Nhận",
    "Booster": "Tăng cường",
    "RentPeriod": "Thời gian thuê",
    "days30": "30 ngày",
    "Dailyprofit": "Lợi nhuận hàng ngày",
    "Totalprofit": "Tổng lợi nhuận",
    "Quantity": "Số lượng",
    "RentPrice": "Giá thuê",
    "RentMiner": "Thuê máy đào",
    "Insufficient": "Không đủ người được mời",
    "InsufficientMsg": "Bạn cần mời {num} bạn bè để kiếm thêm phụ kiện.",
    "Settings": "Cài đặt",
    "copyid": "Sao chép ID",
    "UpgradeSuccessfully": "Nâng cấp thành công",
    "Name": "Tên",
    "userinfo": "Thông tin người dùng",
    "disconnect": "Ngắt kết nối",
    "Startmining": "Bắt đầu khai thác",
    "Welcome": "Chào mừng đến với {name}",
    "Withdrawal": "Rút tiền",
    "Minimumamount": "Số tiền tối thiểu",
    "Networkfee": "Phí mạng",
    "Enteramount": "Nhập số tiền",
    "Submit": "Gửi",
    "MinimumTip": "Số tiền rút quá nhỏ. Số tiền rút tối thiểu: {num}",
    "MaximumTip": "Số tiền không đủ, số tiền tối đa bạn có thể rút là: {num}",
    "SubmittedTip": "Đã gửi, dự kiến sẽ được xử lý trong 30-60 ngày làm việc",
    "WebSubmittedTip": "Đã gửi, chúng tôi sẽ xử lý càng sớm càng tốt.",
    "WithdrawStatus": "Trạng thái",
    "Submissiontime": "Thời gian gửi",
    "WithdrawAwaitTip": "* Dự kiến mất 30-60 ngày làm việc. Mời thêm bạn bè có thể làm nhanh quá trình xem xét.",
    "WebWithdrawAwaitTip": "* Dự kiến mất 24-48 giờ. Mời thêm bạn bè có thể làm nhanh quá trình xem xét.",
    "Processing": "Đang xử lý",
    "Success": "Thành công",
    "Rejection": "Bị từ chối",
    "Amount": "Số tiền",
    "Numberoffriends": "Số lượng bạn bè: {now}/{limit}",
    "InviteTip": "Để thực hiện lần rút đầu tiên, bạn cần mời {limit} bạn bè tham gia ứng dụng đào.",
    "openonphone": "Mở liên kết này trên điện thoại của bạn.",
    "claimTip": "Số tiền cần nhận quá nhỏ. Số tiền tối thiểu để nhận là: {num}",
    "WalletBalance": "Số dư ví",
    "Withdraw": "Rút tiền",
    "SetWalletAddress": "Thiết lập địa chỉ ví",
    "WithdrawalRecord": "Ghi chép rút tiền",
    "Norecords": "Không có ghi chép",
    "Whatis": "{name} là gì?",
    "All": "Tất cả",
    "save": "Lưu",
    "successWithdrawal": "Quét thành công {num}",
    "secondsago": "{time} giây trước",
    "Loading": "Đang tải...",
    "PaymentConfirming": "Đang kiểm tra trạng thái giao dịch...",
    "Check": "Kiểm tra",
    "CheckFail": "Giao dịch chưa hoàn tất. Vui lòng kiểm tra lại sau 5 giây.",
    "Addname": "Thêm '{name}' vào tên của bạn",
    "Restattcheck": "Khởi động lại ứng dụng để kiểm tra",
    "Copyname": "Sao chép '{name}'",
    "SubmissionFailed": "Gửi không thành công, xin vui lòng thử lại sau",
    "WithdrawalReview": "Xem xét rút tiền",
    "select_payment_method": "Chọn phương thức thanh toán",
    "total_amount": "Tổng số tiền",
    "next_step": "Bước tiếp theo",
    "creating_order": "Đang tạo đơn hàng...",
    "order_created": "Đơn hàng đã được tạo",
    "order_status": "Trạng thái đơn hàng",
    "order_id": "Mã đơn hàng",
    "order_amount": "Số tiền đơn hàng",
    "order_status_desc": "Mô tả trạng thái đơn hàng",
    "payment_cancelled": "Thanh toán đã bị hủy",
    "opening_payment": "Đang mở thanh toán...",
    "payment_success": "Thanh toán thành công",
    "payment_failed": "Thanh toán không thành công",
    "payment_pending": "Thanh toán đang chờ xử lý",
    "payment_processing": "Đang xử lý thanh toán",
    "create_order_failed": "Tạo đơn hàng thất bại",
    "creating_ton_order": "Đang tạo đơn hàng TON...",
    "check_payment_status": "Đang kiểm tra tình trạng thanh toán...",
    "use_ton_payment": "Sử dụng thanh toán TON",
    "connect_wallet": "Kết nối ví",
    "start_transaction": "Bắt đầu giao dịch",
    "address": "Địa chỉ",
    "amount_ton": "Số lượng TON",
    "copy": "Sao chép",
    "comment_memo": "Ghi chú memo",
    "comment_memo_desc": "Vui lòng nhập ghi chú memo",
    "comment_memo_placeholder": "Nhập ghi chú memo",
    "amount": "Số lượng",
    "wallet_address": "Địa chỉ ví",
    "you_can_choose_to_connect_wallet_to_pay": "Bạn có thể chọn kết nối ví để thanh toán",
    "or_manually_transfer_to_the_above_address": "Hoặc chuyển khoản thủ công đến địa chỉ trên (lưu ý rằng số lượng và ghi chú phải hoàn toàn giống nhau)",
    "transaction_success": "Giao dịch thành công",
    "transaction_failed": "Giao dịch thất bại",
    "transaction_error": "Lỗi giao dịch",
    "transaction_status": "Tình trạng giao dịch",
    "transaction_id": "ID giao dịch",
    "transaction_amount": "Số tiền giao dịch",
    "transaction_status_desc": "Mô tả tình trạng giao dịch",
    "miner_detail": "Chi tiết thợ đào",
    "rent_period": "Thời gian thuê",
    "days": "{days} ngày",
    "daily_yield": "Lợi nhuận hàng ngày",
    "total_yield": "Tổng lợi nhuận",
    "invite_friends": "Mời bạn bè",
    "price": "Giá",
    "rent": "Thuê",
    "free_claim": "Nhận thưởng miễn phí",
    "redeem": "Đổi thưởng",
    "buy": "Thuê",
    "invite_friends_not_enough": "Mời bạn bè không đủ",
    "redeem_success": "Đổi thưởng thành công",
    "redeem_failed": "Đổi thưởng thất bại",
    "rent_success": "Thuê thành công",
    "rent_failed": "Thuê thất bại",
    "TotalPower": "Tổng công suất",
    "MaxQuantity": "Giá trị tối đa đã đạt",
    "Running": "Đang chạy",
    "Stop": "Dừng lại",
    "Withdrawalunlock": "Mở khóa rút tiền",
    "Close": "Đóng",
    "Delivering": "Đang giao hàng",
    "Duetothelargenumber": "Do số lượng người nhận lớn, airdrop của bạn dự kiến sẽ đến trong 15-20 ngày làm việc",
    "WithdrawalunlockTip": "Bạn cần {num} bạn bè được mời để hoàn thành nhiệm vụ/liên kết ví để mở khóa rút tiền",
    "mining_title": "Robot",
    "Upgrade": "Cập nhật",
    "partner": "Đối tác",
    "faq": "Câu hỏi thường gặp",
    "task": "Nhiệm vụ",
    "OpenRobot": "Mở Robot",
    "MyRobot": "Robot của tôi",
    "Level": "Cấp độ",
    "Commission": "Hoa hồng",
    "DirectFriends": "Bạn bè trực tiếp",
    "Feedback": "Phản hồi",
    "Pleaseenteryouremailaddress": "Vui lòng nhập địa chỉ email của bạn",
    "Inputfeedbackcontent": "Nhập nội dung phản hồi",
    "Submitfeedback": "Gửi phản hồi",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Đã gửi phản hồi thành công, cảm ơn bạn vì phản hồi quý giá của bạn",
    "Feedbacksubmissionfailed,pleaseretriy": "Gửi phản hồi không thành công, vui lòng thử lại",
    "Addressformaterror": "Lỗi định dạng địa chỉ",
    "Readclipboardfailed": "Đọc clipboard không thành công",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Bạn đã phản hồi hôm nay, vui lòng quay lại vào ngày mai",
    "Record": "Ghi chép",
    "Newuserguidance": "Xem Tour Chào Mừng",
    "Usetonwallet": "Sử dụng ví TON",
    "Reward": "Phần thưởng",
    "Connectwallet": "Kết nối ví",
    "Notconnected": "Chưa kết nối",
    "Disconnect": "Ngắt kết nối",
    "AboutTAI": "Chi tiết Token",
    "WithdrawalRecordDesc": "Ghi chú rút tiền",
    "StartAItrading": "Bắt đầu giao dịch AI",
    "Next": "Kế tiếp",
    "Start": "Bắt đầu",
    "WithdrawalSuccess": "Rút tiền thành công",
    "WithdrawalFail": "Rút tiền không thành công",
    "Max": "Tối đa",
    "WithdrawalRecords": "Ghi chú rút tiền",
    "Commissionrules": "Quy tắc hoa hồng",
    "Mycommission": "Hoa hồng của tôi",
    "Shop": "Cửa hàng",
    "BuyDifferentAIrobots": "Nâng cấp với thiết bị máy tính để quét nhanh hơn!",
    "CurrentRunningAIrobots": "Robot AI đang hoạt động hiện tại",
    "DailyProfit": "Lợi nhuận hàng ngày",
    "Buy": "Mua",
    "ValidityPeriod": "Thời gian hiệu lực",
    "Days": "Ngày",
    "Price": "Giá",
    "APY": "APY",
    "NoRobot": "Không có sức mạnh tính toán",
    "RemainingTime": "Thời gian còn lại",
    "InviteandEarn": "Giới thiệu và kiếm tiền",
    "InvitDec": "Giới thiệu bạn bè của bạn tham gia giao dịch AI và cùng kiếm hoa hồng USDT và token airdrop!",
    "ShareToGroups": "Chia sẻ vào các nhóm",
    "Select_payment_method": "Chọn phương thức thanh toán",
    "twa_pay_tip_with_memo": "Vui lòng đảm bảo địa chỉ, số tiền và ghi chú là nhất quán cho giao dịch chuyển tiền.",
    "twa_pay_tip": "Vui lòng đảm bảo địa chỉ và số tiền là chính xác cho giao dịch chuyển tiền.",
    "twa_pay_tip_placeholder": "Nhập ghi chú bình luận",
    "twa_pay_tip_placeholder_with_memo": "Nhập ghi chú bình luận có ghi chú",
    "twa_pay_tip_placeholder_without_memo": "Nhập ghi chú bình luận không có ghi chú",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Nhập ghi chú bình luận có ghi chú",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Nhập ghi chú bình luận không có ghi chú",
    "realtime_ai": "Giao dịch AI Thực Thời",
    "check_transaction_status": "Kiểm tra trạng thái giao dịch",
    "transaction_wait": "Giao dịch đang được xử lý. Bạn có thể thoát khỏi ứng dụng. Một tin nhắn sẽ thông báo cho bạn khi nó hoàn tất.",
    "Pleaseenteravalidemailaddress": "Vui lòng nhập địa chỉ email hợp lệ",
    "max_robot_tip": "Giới hạn mua đã đạt — hãy thử một kế hoạch khác để tiếp tục giao dịch!",
    "connectFailure": "Kết nối ví thất bại",
    "connectSuccess": "Kết nối ví thành công",
    "PayNow": "Thanh toán ngay",
    "min_withdrawal_amount": "Số tiền rút tối thiểu là {num} {coin_name}",
    "max_withdrawal_amount": "Số tiền rút tối đa là {num} {coin_name}",
    "balance_not_enough": "Bạn không có đủ số dư cho giao dịch rút này.",
    "Numberofgroups": "Số lượng nhóm: {now}/{limit}",
    "Withdraw_success": "Rút tiền thành công",
    "allProfit": "Tổng lợi nhuận",
    "AnnualProfit": "Lợi nhuận hàng năm",
    "ScanWallet": "Quét Ví",
    "wallet_check": "wallet_check",
    "Found": "Đã tìm thấy",
    "ScanSpeed": "Tốc độ quét",
    "MyComputingPower": "Tính toán",
    "Scanning": "Đang quét!",
    "WithdrawDetail": "Chi tiết rút tiền",
    "ScanSuccess": "Tỷ lệ thành công quét của bạn đã tăng!",
    "TaskDescription": "Hoàn thành nhiệm vụ để tăng tỷ lệ thành công quét của bạn!",
    "InitializingMiningSystem": "Khởi tạo hệ thống quét...",
    "NoWithdrawalRecord": "Không có hồ sơ rút tiền",
    "Invite": "Các lời mời cần thiết",
    "Free": "Miễn phí",
    "Confirm": "Xác nhận",
    "RefreshTasks": "Làm mới nhiệm vụ",
    "NumberofGroups": "Số nhóm: {now}/{limit}",
    "SendMessage": "Gửi tin nhắn",
    "NumberofShares": "Số lượt chia sẻ: {now}/{limit}",
    "NumberofTasks": "Số nhiệm vụ: {now}/{limit}",
    "CompleteTask": "Hoàn thành nhiệm vụ",
    "Accelerated": "Tăng tốc",
    "Accelerated_withdrawals_success": "Rút tiền nhanh chóng thành công",
    "GoBuy": "Mua ngay",
    "SpeedUpScan": "Tăng Tốc",
    "Earnings": "Thu nhập",
    "learnMore": "Tìm hiểu thêm",
    "claimSuccess": "Nhận thưởng thành công",
    "claimFailed": "Nhận thưởng thất bại, vui lòng thử lại",
    "noDividends": "Không có cổ tức để nhận",
    "dividendsInfoFallback": "Invitet bạn bè để nhận thưởng giới thiệu"
}};